import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../../services/apiAxios';
import helpers from '../../../mixins/helpers';
import moment from 'moment';

const state = {
    informeRentabilidad: [],
    informeReinversion: [],
    retirosSocios: [],
    sueldosRetiros: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_INDICADORES' (state) {
        state.informeRentabilidad =  [];
        state.informeReinversion =  [];
    },

    'SET_INFORME_RENTABILIDAD'(state, informe) {
        state.informeRentabilidad = informe.rentabilidadSocios;
        state.informeReinversion =  informe.reinversion;
    },

    'INICIALIZAR_RETIROS' (state) {
        state.retirosSocios =  [];
    },
    'SET_RETIROS'(state, retirosSocios) {
        state.retirosSocios = retirosSocios;
    },
    'INICIALIZAR_SUELDOS' (state) {
        state.sueldosRetiros =  [];
    },
    'SET_SUELDOS'(state, sueldosRetiros) {
        state.sueldosRetiros = sueldosRetiros;
    },
};

const getters = {
    getField,

    informeRentabilidad(state) {
        return state.informeRentabilidad;
    },
    informeReinversion(state) {
        return state.informeReinversion;
    },
    retirosSocios(state) {
        return state.retirosSocios;
    },
    sueldosRetiros(state) {
        return state.sueldosRetiros;
    },
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES');
            resolve();
        })
    },

    getInformeRentabilidad ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES');

            apiAxios.get('indicadores/socios/informe-rentabilidad')
                .then(res => {
                    commit('SET_INFORME_RENTABILIDAD', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getRetirosSocios ( { commit }, anio ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RETIROS');

            let queryString = `?fechaDesde=${anio}-01-01&fechaHasta=${anio}-12-31&socios=true`;

            apiAxios.get('ingresosegresos/list' + queryString)
                .then(res => {
                    commit('SET_RETIROS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getSueldosRetiros ( { commit }, anio ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_SUELDOS');

            let queryString = `?fechaDesde=${anio}-01-01&fechaHasta=${anio}-12-31`;

            apiAxios.get('liquidacionessueldos/retiros' + queryString)
                .then(res => {
                    commit('SET_SUELDOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}